export default __webpack_public_path__ + "static/media/noNotes.77ff9f99.svg";